export default __webpack_public_path__ + "static/media/form-oops.341da8e3.png";